import { Box, CheckBox, ModBox, Spacer, TextNew } from '@jfs/ui-new'
import { ButtonNew } from '../AdminButton'
import { FC, ReactElement, useEffect, useState } from 'react'
import { styles } from './styles'
import { FilterItemProps, FilterProps, filterTypes } from './types'

export const FilterItem: FC<FilterItemProps> = ({
  hide,
  header,
  mode,
  updateFilters,
  filterData,
  checkSelected,
  selectedValue,
}: FilterItemProps) => {
  const themedStyle = styles()
  if (hide) {
    return null
  }
  const filtersObj = filterData // filterData[mode]
  const isModeSearch =
    mode === filterTypes.level ||
    mode === filterTypes.status ||
    mode === filterTypes.applicationStatus ||
    mode === filterTypes.auditType
  const keys = isModeSearch ? Object.values(filtersObj) : Object.keys(filtersObj)

  const filterChild = keys?.map((element: any) => {
    const handleFilter = (): void => {
      console.log('selectedValue, element', selectedValue, mode, element)
      updateFilters(mode, element)
    }

    const isChecked = isModeSearch
      ? selectedValue?.toLowerCase() === element?.toLowerCase() || checkSelected(mode, element)
      : selectedValue?.toLowerCase() === filtersObj?.[element]?.toLowerCase() || checkSelected(mode, element)

    return (
      <Box onPress={handleFilter} {...themedStyle.childContainer}>
        <CheckBox
          checked={isChecked || selectedValue?.toLowerCase() === 'all'}
          onChange={handleFilter}
          iconSize={16}
          color={isChecked || selectedValue?.toLowerCase() === 'all' ? 'PRIMARY' : 'BLACK_LIGHT'}
        />
        <Spacer size={8} direction="horizontal" />
        <TextNew type="body12" color="PRIMARY_GREY" fontFamily="jiotype-medium">
          {isModeSearch ? element : filtersObj[element]}
        </TextNew>
      </Box>
    )
  })

  return (
    <Box {...themedStyle.innerContainer}>
      <TextNew type="body14" color="BLACK_21" fontFamily="jiotype-medium">
        {header}
      </TextNew>
      <Spacer size={12} direction="vertical" />
      <Box>{filterChild}</Box>
    </Box>
  )
}

export const Filters: FC<FilterProps> = ({
  onPress,
  selectedFilteredData,
  updateFilters,
  filterData,
  checkSelected,
  apply,
  selectedValue,
  mode,
  restoreDefaults,
}: FilterProps): ReactElement => {
  const [initialState, setInitialState] = useState(0)
  const [initialData, setInitialData] = useState<any>({})

  useEffect(() => {
    if (initialState < 1) {
      setInitialData(selectedFilteredData)
    }
  }, [initialState, selectedFilteredData])

  const themedStyle = styles()

  const updateHandler = (modeSelected: filterTypes, value: string): void => {
    setInitialState((prev: number): number => prev + 1)
    updateFilters(modeSelected, value)
  }

  const handleCancel = (): void => {
    // updateFilterSettings(initialData)
    onPress()
  }

  const restoreDefault = () => {
    restoreDefaults && restoreDefaults()
  }

  const handleApply = (): void => {
    apply()
  }

  const handleFilter = (value: string, type: string) => {
    setInitialState((prev: number): number => prev + 1)
  }

  const getRestoreStyles: any = () => {
    return {
      ...themedStyle.bottomBar,
      justifyContent: 'space-between',
    }
  }

  return (
    <Box {...themedStyle.outerContainer}>
      <Box {...themedStyle.topBar}>
        <TextNew type="body18" color="BLACK_21" fontFamily="jiotype-medium">
          {'Filters'}
        </TextNew>
        <TextNew type="body14" color="PRIMARY_GREY" fontFamily="jiotype-medium">
          {'Filter the data to be shown in the table'}
        </TextNew>
      </Box>
      <ModBox {...themedStyle.container}>
        {filterData &&
          filterData.map((filter: any, index: number) => {
            return (
              <FilterItem
                header={filter?.title}
                filterData={filter?.data}
                updateFilters={updateHandler}
                mode={filter?.mode}
                checkSelected={checkSelected}
                selectedValue={Array.isArray(selectedValue) ? selectedValue[index] : selectedValue}
              />
            )
          })}
      </ModBox>
      <Box {...getRestoreStyles()}>
        <ButtonNew title={'Reset To Default Settings'} {...themedStyle.restoreDefault} onPress={restoreDefault} />
        <Box {...themedStyle.filterHeader}>
          <ButtonNew title={'Cancel'} {...themedStyle.cancel} onPress={handleCancel} />
          <Spacer size={16} direction="horizontal" />
          <ButtonNew title={'Apply'} {...themedStyle.apply} onPress={handleApply} />
        </Box>
      </Box>
    </Box>
  )
}
